var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.9999C1 16.5041 3.70858 20.3736 7.58445 22.0748C7.55351 21.3067 7.57895 20.3847 7.77591 19.5489C7.98741 18.656 9.19131 13.5551 9.19131 13.5551C9.19131 13.5551 8.83991 12.8528 8.83991 11.8148C8.83991 10.1847 9.7847 8.96722 10.9614 8.96722C11.9619 8.96722 12.4453 9.71872 12.4453 10.6186C12.4453 11.6244 11.8038 13.1289 11.4739 14.5223C11.1983 15.6892 12.059 16.6409 13.2101 16.6409C15.2942 16.6409 16.6979 13.9641 16.6979 10.7926C16.6979 8.38174 15.0742 6.57728 12.1207 6.57728C8.78396 6.57728 6.70522 9.06562 6.70522 11.8451C6.70522 12.8035 6.98778 13.4792 7.43036 14.0026C7.63386 14.243 7.66213 14.3396 7.58848 14.6157C7.53572 14.818 7.41455 15.3053 7.36436 15.4984C7.29114 15.777 7.06538 15.8766 6.81359 15.7737C5.27668 15.1463 4.56091 13.4633 4.56091 11.5713C4.56091 8.44662 7.19627 4.69985 12.4226 4.69985C16.6224 4.69985 19.3866 7.73886 19.3866 11.001C19.3866 15.3161 16.9876 18.5398 13.4512 18.5398C12.2637 18.5398 11.1466 17.8979 10.7639 17.1687C10.7639 17.1687 10.1253 19.7031 9.99001 20.1925C9.75677 21.0406 9.30027 21.8883 8.88287 22.5489C9.87219 22.8409 10.9173 23 12.0004 23C18.0748 23 23.0001 18.0751 23.0001 11.9999C23.0001 5.92486 18.0748 1 12.0004 1C5.92542 1 1 5.92486 1 11.9999Z",
    fill: "#CB1F27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.a78c3a2b.svg";
export { ForwardRef as ReactComponent };